import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Input } from 'antd'
import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { PageHeader } from '~/components/PageHeader'
import { type CouponCode } from '~/types/coupon-codes'
import { CouponFormModal } from './CouponFormModal'
import CouponList from './CouponList'

export default function CouponCodePage() {
  const [filterInput, setFilterInput] = useState<string | null>(null)
  const [edit, setEdit] = useState<CouponCode | null>(null)
  const [openModal, setOpenModal] = useState(false)
  const queryClient = useQueryClient()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filters, setFilters] = useState<Record<string, any>>({})
  return (
    <>
      <PageHeader
        className='radup-page-header'
        title='Coupons'
        extra={[
          <Input.Search
            key={1}
            placeholder='Search for coupon codes'
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={setFilterInput}
            style={{ width: 300 }}
          />,
          <Button
            key={2}
            type='primary'
            onClick={() => {
              setOpenModal(true)
            }}
          >
            <PlusOutlined /> New coupon
          </Button>
        ]}
      />

      <CouponList
        onEdit={(item) => {
          setEdit(item)
          setOpenModal(true)
        }}
        searchValue={filterInput}
        onFilter={setFilters}
      />

      {
        <CouponFormModal
          open={openModal}
          coupon={edit}
          onClose={() => {
            setOpenModal(false)
            setEdit(null)
            queryClient.invalidateQueries({ queryKey: ['coupons'] })
          }}
        />
      }
    </>
  )
}
